import { Action } from 'store/store';
import { NotificationType } from '@instinet-analytics/semantic-ui-components';

export enum NotificationActionType {
    SHOW_NOTIFICATION = 'SHOW_NOTIFICATION',
    HIDE_NOTIFICATION = 'HIDE_NOTIFICATION',
    HIDE_ALL_NOTIFICATIONS = 'HIDE_ALL_NOTIFICATIONS',
}

export interface ShowNotificationPayload {
    id: string;
    type: NotificationType;
    title?: string;
    message: string;
}

export type ShowNotificationAction = Action<
    NotificationActionType.SHOW_NOTIFICATION,
    ShowNotificationPayload
>;

export const showNotificationAction: (
    id: string,
    message: string,
    type: NotificationType,
    title?: string
) => ShowNotificationAction = (
    id: string,
    message: string,
    type: NotificationType,
    title?: string
) => ({
    type: NotificationActionType.SHOW_NOTIFICATION,
    payload: { id, title, type, message },
});

export type HideNotificationAction = Action<
    NotificationActionType.HIDE_NOTIFICATION,
    { id: string }
>;

export const hideNotificationAction: (id: string) => HideNotificationAction = (
    id: string
) => ({
    type: NotificationActionType.HIDE_NOTIFICATION,
    payload: { id },
});

export type HideAllNotificationActions =
    Action<NotificationActionType.HIDE_ALL_NOTIFICATIONS>;

export const hideAllNotificationsAction: () => HideAllNotificationActions =
    () => ({
        type: NotificationActionType.HIDE_ALL_NOTIFICATIONS,
    });

export type NotificationAction =
    | ShowNotificationAction
    | HideNotificationAction
    | HideAllNotificationActions;
